let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4SSkP")).then(() => parcelRequire('5vbLS'));